import truncate from 'lodash-es/truncate';

function truncateText(text: string, limit: number, omission = '...') {
  return truncate(text, {
    length: limit + omission.length,
    omission,
  });
}

export function truncateTextWithLimit(
  text: string,
  limit: number,
  omission = '...',
) {
  return text.length > limit ? text.slice(0, limit) + omission : text;
}

export default truncateText;
